<template>
     <div class="ownercontract-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Owner's Contract" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="ownercontract-id" 
                type="hidden" 
                v-model="ownercontract.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Contract Date:"
                    label-for="ownercontract-date_contract"
                    >
                    <b-form-input
                    id="ownercontract-date_contract"
                    type="date"
                    v-model="ownercontract.date_contract"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Landlord:" 
                        label-for="ownercontract-owner_id_contract">
                        <b-select 
                            id="ownercontract-owner_id_contract"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="owners" 
                            @input="loadOwnerImmobiles(ownercontract.owner_id_contract)"
                            v-model="ownercontract.owner_id_contract" 
                            />
                    </b-form-group>
                </b-col> 
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="Property:" 
                        label-for="ownercontract-immobile_id_contract">
                        <b-select 
                            id="ownercontract-immobile_id_contract"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobiles" 
                            v-model="ownercontract.immobile_id_contract" 
                            />
                    </b-form-group>
                </b-col>
                 <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="ownercontract.active_contract" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="ownercontract-active_contract"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" 
                                for="ownercontract-active_contract">
                                Active?
                            </label>
                        </div>
                    </div>
                </b-col> 
             </b-row>
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Day for Payment:"
                        label-for="ownercontract-day_for_payment_contract"
                        >
                        <b-form-input
                            id="ownercontract-day_for_payment_contract"
                            v-model="ownercontract.day_for_payment_contract"
                            type="number"
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                        <b-form-group
                            label="Value Payment:"
                            label-for="ownercontract-value_payment_contract"
                        >
                            <b-form-input
                                id="ownercontract-value_payment_contract"
                                type="number"
                                v-model="ownercontract.value_payment_contract"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            />
                        </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                        label="Day for Receive:"
                        label-for="ownercontract-day_for_receive_contract"
                        >
                        <b-form-input
                            id="ownercontract-day_for_receive_contract"
                            v-model="ownercontract.day_for_receive_contract"
                            type="number"
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
                 <!--b-col md="3" sm="12">
                        <b-form-group
                            label="Value Receive:"
                            label-for="ownercontract-value_receive_contract"
                        >
                            <b-form-input
                                id="ownercontract-value_receive_contract"
                                type="number"
                                v-model="ownercontract.value_receive_contract"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            />
                        </b-form-group>
                </b-col-->
                 <b-col md="2" sm="12">
                    <b-form-group
                        label="Contract Months:"
                        label-for="ownercontract-contract_month_contract"
                        >
                        <b-form-input
                            id="ownercontract-contract_month_contract"
                            v-model="ownercontract.contract_month_contract"
                            type="number"
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        />
                    </b-form-group>
                </b-col>
                
                   
             </b-row>
            <b-card class="ownercontract-search-card">
                    <b-tabs card >
                        <b-tab title="Detail" active>
                        <b-form>
                        <b-row>
                        <b-button  
                            title="Add Location" 
                            size="sm" 
                            class="mb-2 md-2 mr-2 fa fa-plus" 
                            variant="dark" 
                            v-if="ownercontract.id > 0"
                            @click="openModalImmobile">
                        </b-button>
                        <b-button  
                            title="Add All Location" 
                            size="sm" 
                            class="mb-2 mr-2 fa fa-user-plus" 
                            variant="dark" 
                            v-if="ownercontract.id > 0 && ownercontractitems.length === 0"
                            @click="createAllImmobile">
                        </b-button>
                        <b-button  
                            title="Refresh" 
                            size="sm" 
                            class="mb-2 mr-2 fa fa-refresh" 
                            variant="dark" 
                            @click="loadOwnerContractItems()">
                        </b-button>
                        </b-row>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="ownercontractitems" 
                            :fields="fieldImmobile">

                        <template v-slot:cell(actions)="data">
                             <b-button 
                                title="Property Details" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalImmobile()]" class="mr-2 mt-2">
                                <i class="fa fa-external-link"></i>
                            </b-button>
                            <b-button 
                                title="Edit" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalImmobile()]" class="mr-2 mt-2">
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteImmobile(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                        </b-table>
                        </transition>                             
                            </b-row>
                        </b-form>

                        </b-tab >
                         <b-tab title="Tenants" >

                           <b-card class="owner-search-card">

                              <b-tabs card >
                                <b-tab title="Active" active>
                                    <b-row>
                                        <transition  name="slide" type="animation" appear>       
                                            <b-table 
                                            class="table-responsive" 
                                            hover 
                                            key="slide"  
                                            head-variant="light" 
                                            :items="ownercontracttenantsactives" 
                                            :fields="fieldsTenants">
                                            </b-table>
                                        </transition>  
                                    </b-row>
                                </b-tab>
                                <b-tab title="Inactive" >
                                     <b-row>
                                        <transition  name="slide" type="animation" appear>       
                                            <b-table 
                                            class="table-responsive" 
                                            hover 
                                            key="slide"  
                                            head-variant="light" 
                                            :items="ownercontracttenantsnoactives" 
                                            :fields="fieldsTenants">
                                            </b-table>
                                        </transition>  
                                    </b-row>
                                </b-tab>

                              </b-tabs>

                           </b-card>      

                         </b-tab>
                           <b-tab title="Financial Detail" >
                            <b-form>
                                <b-row>
                                    <b-button  
                                        size="sm" 
                                        variant="light" 
                                        title="Add"
                                        class="mt-2  mb-2 fa fa-plus" 
                                        @click="openModalFinancialContract">
                                    </b-button>
                                </b-row>
                                  <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            :per-page="perPage" 
                            :current-page="currentPageFinancial" 
                            head-variant="light" 
                            :items="ownercontractfinancialdetails" 
                            :fields="fielsFinancial">
                              <template v-slot:cell(actions)="data">
                                <b-button  
                                    title = "Report payment" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[loadFinancial(data.item),openModalFinancialContract()]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                                 <b-button 
                                    title="Delete" 
                                    size="sm" 
                                    variant="light" 
                                    @click="showMsgBoxDeleteFinancial(data.item)" 
                                    class="mr-2 mt-2">
                                <i class="fa fa-trash"></i>
                                </b-button>
                               
                              </template>
                     
                        </b-table>
                        </transition>   
                        <b-pagination
                           v-show="showTable"
                            v-model="currentPageFinancial"
                            :total-rows="rowsFinancial"
                            :per-page="perPage"
                            size="sm"
                            aria-controls="my-table"
                        ></b-pagination>                          
                            </b-row>
                            </b-form>
                           </b-tab>
                          <b-tab title="Electronic Document" >
                              <b-form>
                                     <b-row>
                                         <b-button  
                                            title="Add File" 
                                            size="sm" 
                                            class="mb-2 fa fa-plus" 
                                            variant="dark" 
                                            v-if="ownercontract.id > 0"
                                            @click="openModalFile">
                                        </b-button>
                                     </b-row>
                                      <b-row>
                                             <transition  name="slide" type="animation" appear>  

                                                     <b-table 
                                                        class="table-responsive" 
                                                        hover 
                                                        key="slide"  
                                                        head-variant="light" 
                                                        :items="ownercontractdocumenteletronics" 
                                                        :fields="fieldFile">
                                                         <template v-slot:cell(actions)="data">
                                                        <b-button  
                                                            title = "View" 
                                                            size="sm" 
                                                            variant="light" 
                                                            @click="openUrlFile(data.item)" 
                                                            class="mr-2 mt-2">
                                                            <i class="fa fa-file-pdf-o"></i>
                                                        </b-button>
                                                     </template>
                                                    </b-table>
                                                    

                                             </transition>
                                      </b-row>
                              </b-form>
                          </b-tab>
                    </b-tabs>
                    
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwnerContracts(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by landlord name or Address" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                 <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                <b-dropdown id="dropdown-form-offset" size="sm" text="..." ref="dropdown" variant="outline-info" class="mr-2 mt-2">
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    </b-dropdown>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
         <b-modal
            id="modalImmobileContract"
            ref="modal"
            title-tag="h6"
            title="Property"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobile"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Location:"
                            label-for="ownercontractitem-immobile_item_id_contract_item"
                        >
                            <b-form-select
                                id="ownercontractitem-immobile_item_id_contract_item"
                                size="sm"
                                :options="typeimmobiles"
                                v-model="ownercontractitem.immobile_item_id_contract_item"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <!--b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Value Payment:"
                            label-for="ownercontractitem-value_payment_contract_item"
                        >
                            <b-form-input
                                id="ownercontractitem-value_payment_contract_item"
                                type="number"
                                v-model="ownercontractitem.value_payment_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Value Receive:"
                            label-for="ownercontractitem-value_receive_contract_item"
                        >
                            <b-form-input
                                id="ownercontractitem-value_receive_contract_item"
                                type="number"
                                v-model="ownercontractitem.value_receive_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row-->
          </b-form>
        </b-modal>
         <b-modal
            id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Contract File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveFile"
        >
            <b-form>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                        label="Date:"
                        label-for="ownercontractdocumenteletronic-owner_contract_date_doc"
                        >
                        <b-form-input
                        id="ownercontractdocumenteletronic-owner_contract_date_doc"
                        type="date"
                        v-model="ownercontractdocumenteletronic.owner_contract_date_doc"
                        size="sm"
                        />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="File:"
                            label-for="ownercontractdocumenteletronic-file"
                        >
                            <b-form-file
                                v-model="file"
                                id="ownercontractdocumenteletronic-file"
                                ref="file"
                                @input="saveImagem"
                                class="mt-3"
                                placeholder="Search a file..."
                                accept=".pdf"
                            ></b-form-file>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
           <b-modal
            id="modalFinancialContract"
            ref="modal"
            title-tag="h6"
            title="Financial details"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveFinancial"
        >
            <b-form>
                <b-row>
                     <b-col md="4" sm="12">
                        <b-form-group
                        label="Due Date:"
                        label-for="ownercontractfinancialdetail-due_date_financial_detail"
                        >
                        <b-form-input
                        id="ownercontractfinancialdetail-due_date_financial_detail"
                        type="date"
                        v-model="ownercontractfinancialdetail.due_date_financial_detail"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                        <b-col md="4" sm="12">
                        <b-form-group
                        label="Payment Date:"
                        label-for="ownercontractfinancialdetail-receipt_date_financial_detail"
                        >
                        <b-form-input
                        id="ownercontractfinancialdetail-receipt_date_financial_detail"
                        type="date"
                        v-model="ownercontractfinancialdetail.receipt_date_financial_detail"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                     <b-col md="4" sm="12">
                        <b-form-group
                            label="Value:"
                            label-for="ownercontractfinancialdetail-value_finacial_detail"
                        >
                            <b-form-input
                                id="ownercontractfinancialdetail-value_finacial_detail"
                                type="number"
                                v-model="ownercontractfinancialdetail.value_finacial_detail"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
              
                <b-row>
                     <b-col md="12" sm="12">
                     <b-form-radio-group
                        v-model="ownercontractfinancialdetail.form_payment_financial_detail"
                        :options="optionsPayment"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        ></b-form-radio-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                    <b-form-group 
                        label="Financial Box:" 
                        label-for="ownercontractfinancialdetail-financial_box_id_financial_detail">
                        <b-select 
                            id="ownercontractfinancialdetail-financial_box_id_financial_detail"
                            size="sm"
                            :options="financialboxs" 
                            v-model="ownercontractfinancialdetail.financial_box_id_financial_detail" 
                            />
                    </b-form-group>
                </b-col> 
                  <b-col md="6" sm="12">
                    <b-form-group 
                        label="Operation:" 
                        label-for="ownercontractfinancialdetail-operation_leve_one_id_detatil">
                        <b-select 
                            id="ownercontractfinancialdetail-operation_leve_one_id_detatil"
                            size="sm"
                            :options="operationslevelones" 
                            v-model="ownercontractfinancialdetail.operation_leve_one_id_detatil" 
                            />
                    </b-form-group>
                </b-col> 
                </b-row>
                <b-row>
                 <b-col md="12" sm="12">
                        <b-form-group 
                            label="Notes:" 
                            label-for="ownercontractfinancialdetail-comments_financial_detail">
                        <b-form-textarea id="ownercontractfinancialdetail-comments_financial_detail"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="ownercontractfinancialdetail.comments_financial_detail"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>
               
            </b-form>
        </b-modal>
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'OwnerContractSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                file:null,
                ownercontract: {},
                ownercontractitem: {},
                ownercontractfinancialdetail:{},
                immobile: {},
                ownercontractdocumenteletronic:{},
                ownercontractitems:[],
                ownercontracttenants:[],
                ownercontracttenantsactives:[],
                ownercontracttenantsnoactives:[],
                ownercontractdocumenteletronics:[],
                ownercontractfinancialdetails:[],
                financialboxs:[],
                owners:[],
                immobiles:[],
                ownercontracts: [],
                typeimmobiles: [],
                operationslevelones:[],
                perPage: 20,
                currentPage: 1,
                currentPageFinancial: 1,
                currentPageFinancialSearch: 1,
                isBusy: false,
                showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    {
                        key: 'date_contract',label: 'Contract Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                     { key: 'active_contract', label: 'Active', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},
                    { key: 'additive_contract', label: 'Additive', sortable: false ,variant: 'light'},
                     { key: 'name_owner', label: 'Landlord Name', sortable: false ,variant: 'light'},
                    { key: 'address_immobile', label: 'Address', sortable: true ,variant: 'light'},
                    { key: 'region_immobile', label: 'Region', sortable: true ,variant: 'light'},
                    { key: 'name_type_mmobile', label: 'Type', sortable: true ,variant: 'light'},
                    { key: 'day_for_payment_contract', label: 'Payment Day', sortable: false ,variant: 'light'},
                    { key: 'day_for_receive_contract', label: 'Receive Day', sortable: false,variant: 'light'},
                    { key: 'contract_month_contract', label: 'Contract Months', sortable: false,variant: 'light'},
                    {
                        key: 'closing_date_contract',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },              
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldImmobile:[
                    { key: 'name_type_part_immobile', label: 'Location', sortable: true },
                    { key: 'number_control_item', label: 'Nº Location', sortable: false },
                    { key: 'name_type_part_immobile_sub', label: 'Sub Location', sortable: false },
                    { key: 'number_control_item_sub', label: 'Nº Sub Location', sortable: false },
                    { key: 'description_item', label: 'Descrition', sortable: true },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
                fieldFile:[
                     {
                        key: 'owner_contract_date_doc',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'owner_contract_name_file_doc', label: 'Name File', sortable: false },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
                fielsFinancial:[
                    {
                        key: 'due_date_financial_detail',label: 'Due Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'value_finacial_detail', label: 'Value', sortable: false },
                     {
                        key: 'receipt_date_financial_detail',label: 'Payment Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    {
                        key: 'form_payment_financial_detail',
                        label: 'Form of Payment',
                        sortable: true,
                        variant: 'light',
                        formatter: value => (value ? this.returnOptionFinancial(value) : '')
                    },
                    { key: 'financial_box_name', label: 'Receipt Local', sortable: false },    
                    { key: 'name_operation_level_one', label: 'Operation', sortable: false },           
                    { key: 'comments_financial_detail', label: 'Notes', sortable: false },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
            fieldsTenants: [
                    {
                        key: 'agreement_date',label: 'Agreement Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    {
                        key: 'closing_date_agreement',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                     { key: 'active_agreement', label: 'Active', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},
                    { key: 'name_tenant', label: 'Tenant', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'number_control_item', label: 'Nº Location', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile_sub', label: 'Sub Location', sortable: false ,variant: 'light'},
                    { key: 'number_control_item_sub', label: 'Nº Sub Location', sortable: false ,variant: 'light'},
                    { key: 'contract_value_agreement', label: 'Value Agreement', sortable: true ,variant: 'light'},
                    { key: 'deposit_amount_agreement', label: 'Deposit Amount', sortable: true ,variant: 'light'},
                    { key: 'contract_months_agreement', label: 'Agreement Months', sortable: false,variant: 'light'},
                     {
                        key: 'approval_date_agreement',label: 'Approval Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    }, 
                             
                { key: 'actions', label: 'Action',variant: 'light' },
            ],
            optionsPayment: [
                    { item: 1, name: 'Cash' },
                    { item: 2, name: 'Bank Transfer' },
                    { item: 3, name: 'Cash/Bank Transfer' },
            ],
        }
    
        },
        computed: {
            filteredList() {
                return this.ownercontracts.filter(ownercontract => {
                    return ownercontract.name_owner.toLowerCase().includes(this.search.toLowerCase()) || ownercontract.address_immobile.toLowerCase().includes(this.search.toLowerCase()) 
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.ownercontracts.length
            },
            rowsFinancial() {
                return this.ownercontractfinancialdetails.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            openModalFinancialContract() {
                this.$bvModal.show('modalFinancialContract')
            },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
             returnOptionFinancial(value) {

                   let descrition_task = ''

                    if(value ===1)
                    {
                        descrition_task = 'Cash'
                    }
                    else if(value === 2)
                    {
                        descrition_task = 'Bank Transfer'
                    }else if(value === 3)
                    {
                        descrition_task = 'Cash/Bank Transfer'
                    }


                return descrition_task
            },
              async showMsgBoxDeleteFinancial(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeFinancial(item)
                    }
                })
            },
            async showMsgBoxDeleteImmobile(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeImmobile(item)
                    }
                })
            },
            loadOwnerContracts(){
                const url = `${baseApiUrl}/ownercontractsbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.ownercontracts = res.data
                      this.isBusy = false
                })
            },
             loadOwnerContractItems(){
                const url = `${baseApiUrl}/ownercontractitemsbycontract/${this.ownercontract.id}`
                axios(url).then(res =>{
                     this.ownercontractitems = res.data
                })
            },
            loadOwnerContractTenantAgreement(){
                 const url = `${baseApiUrl}/tenantagreementbyownercontract/${this.ownercontract.immobile_id_contract}`
                axios(url).then(res =>{
                     this.ownercontracttenants = res.data
                })
            },
            loadOwnerContractTenantAgreementActive(){
                 const url = `${baseApiUrl}/tenantagreementbyownercontractactive/${this.ownercontract.immobile_id_contract}`
                axios(url).then(res =>{
                     this.ownercontracttenantsactives = res.data
                })
            },
            loadOwnerContractTenantAgreementNoActive(){
                 const url = `${baseApiUrl}/tenantagreementbyownercontractnoactive/${this.ownercontract.immobile_id_contract}`
                axios(url).then(res =>{
                     this.ownercontracttenantsnoactives = res.data
                })
            },
            loadOwnerContractFiles(){
                 const url = `${baseApiUrl}/ownercontractdocumenteletronics/${this.ownercontract.id}`
                axios(url).then(res =>{
                     this.ownercontractdocumenteletronics = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.ownercontract = {}
                    this.ownercontractitem = {}
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwnerContracts()              
                this.ownercontract = {}
                this.ownercontractitems = []
            },
            async removeFinancial(item) {
                    axios.delete(`${baseApiUrl}/ownercontractfinancialdetails/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadFinancialDetail()
                        })
                        .catch(showError)
            },
            async save() {

                const method = this.ownercontract.id ? 'put' : 'post'
                const id = this.ownercontract.id ? `/${this.ownercontract.id}` : ''

                if(this.ownercontract.id){
                    this.ownercontract.update_date_contract = this.formatDateTime(Date())
                    this.ownercontract.update_user_id_contract = this.user.id
                }else{
                    this.ownercontract.user_id_contract = this.user.id
                    this.ownercontract.company_id_contract = this.compan.id
                }

                await axios[method](`${baseApiUrl}/ownercontracts${id}`, this.ownercontract)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            async saveImmobile() {

                    if (this.ownercontractitem.id) {
                        this.ownercontractitem.update_user_immobile = this.user.id
                        this.ownercontractitem.update_date_immobile = this.formatDateTime(Date())
                    } else {
                        this.ownercontractitem.user_id_immobile = this.user.id
                    }

                    const method = this.ownercontractitem.id ? 'put' : 'post'
                    const id = this.ownercontractitem.id ? `/${this.ownercontractitem.id}` : ''
                    this.ownercontractitem.owner_contract_id_item = this.ownercontract.id
                    this.ownercontractitem.owner_additive_item = this.ownercontract.additive_contract
                    await axios[method](
                        `${baseApiUrl}/ownercontractitems${id}`,
                        this.ownercontractitem
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.ownercontractitem = {}
                            this.loadOwnerContractItems()

                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.ownercontract.id
                    axios.delete(`${baseApiUrl}/ownercontracts/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeImmobile(item) {
                    axios.delete(`${baseApiUrl}/ownercontractitems/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContractItems()
                        })
                        .catch(showError)
            },

            loadOwner(ownercontract, mode = 'save') {
                this.mode = mode
                if(ownercontract.date_contract) ownercontract.date_contract = this.formatDate(ownercontract.date_contract)
                this.ownercontract = { ...ownercontract }
                this.loadOwnerImmobiles()
                this.loadOwnerContractItems()
                this.loadFinancialDetail()
                //this.loadOwnerContractTenantAgreement()
                this.loadOwnerContractFiles()
                this.loadOwnerContractTenantAgreementActive()
                this.loadOwnerContractTenantAgreementNoActive()
            },
            loadOwnerImmobile(item){
                this.ownercontractitem = {...item}
            },
            openModalImmobile() {
                this.loadOwnerImmobileItems()
                this.$bvModal.show('modalImmobileContract')
            },
            openModalFile() {
                this.$bvModal.show('modalFile')
            },
            openUrlFile(item){
                window.open(item.url_file);
            },
            loadOwners() {
                const url = `${baseApiUrl}/ownersbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.owners = res.data.map(type => {
                        return { value: type.id, text: type.name_owner }
                    })
                })
            },
            loadOwnerImmobiles(item){
                const url = `${baseApiUrl}/immobilebyowner/${item}`
                axios(url).then(res =>{
                     this.immobiles = res.data.map(imobile =>{
                        return {value: imobile.id, text: imobile.address_immobile + '/' + imobile.region_immobile + ' - Status: ' + imobile.status_contract }
                     })
                })
            },
            loadOwnerImmobileItems(){
                const url = `${baseApiUrl}/immobileitemsbyimmobile/${this.ownercontract.immobile_id_contract}`
                axios(url).then(res =>{
                     this.typeimmobiles = res.data.map(imobile =>{
                        return {value: imobile.id, text: imobile.name_type_part_immobile + '-' + imobile.description_item}
                     })
                })
            },
            async saveImagem() {
                let formData = new FormData()
                formData.append('file', this.file)

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.getLastStorageFile()
                    })
                    .catch(showError)
            },
            async getLastStorageFile() {
            const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`
            await axios(url).then(
            res =>
                (this.ownercontractdocumenteletronic = {
                    ...this.ownercontractdocumenteletronic,
                    owner_contract_storage_file_id_doc: res.data.id,
                    owner_contract_name_file_doc: res.data.name_file,
                    owner_contract_path_file_doc: res.data.path_file,
                    owner_contract_id_doc: this.ownercontract.id
                })
            )
            },
            async saveFile(){

                 const method = this.ownercontractdocumenteletronic.id ? 'put' : 'post'
                    const id = this.ownercontractdocumenteletronic.id ? `/${this.ownercontractdocumenteletronic.id}` : ''
                  
                    await axios[method](
                        `${baseApiUrl}/ownercontractdocumenteletronics${id}`,
                        this.ownercontractdocumenteletronic
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.ownercontractdocumenteletronic = {}
                            this.loadOwnerContractFiles()

                        })
                        .catch(showError)

            },
            async createAllImmobile(){
                     const method = 'post'
                     const id = this.ownercontract.id

                     await axios[method](
                        `${baseApiUrl}/createownercontractitems/${id}`
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContractItems()

                        })
            },
            loadFinancialBoxs() {
                const url = `${baseApiUrl}/financialboxbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.financialboxs = res.data.map(type => {
                        return { value: type.id, text: type.financial_box_name }
                    })
                })
            },
            loadFinancialDetail(){
                const url = `${baseApiUrl}/ownercontractfinancialdetailbyowner/${this.ownercontract.id}`
                axios(url).then(res =>{
                     this.ownercontractfinancialdetails = res.data
                })
            },
            loadFinancial(item){

                 if(item.due_date_financial_detail) item.due_date_financial_detail = this.formatDate(item.due_date_financial_detail)
                 if(item.receipt_date_financial_detail) item.receipt_date_financial_detail = this.formatDate(item.receipt_date_financial_detail)
                this.ownercontractfinancialdetail = {...item}
            },
            async saveFinancial() {

                    if(!this.ownercontractfinancialdetail.id > 0){
                        this.ownercontractfinancialdetail.company_id_financial_detail = this.compan.id
                        this.ownercontractfinancialdetail.owner_contract_id_financial_detail = this.ownercontract.id

                    }
             
                    const method = this.ownercontractfinancialdetail.id ? 'put' : 'post'
                    const id = this.ownercontractfinancialdetail.id ? `/${this.ownercontractfinancialdetail.id}` : ''
                    await axios[method](
                        `${baseApiUrl}/alterownercontractfinancialdetails${id}`,
                        this.ownercontractfinancialdetail
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.ownercontractfinancialdetail = {}
                            this.loadFinancialDetail()
                           // this.loadFinancialControls()
                        })
                        .catch(showError)
            },
           async loadOperationsLevelOnes() {
                    const url = `${baseApiUrl}/operationslevelones/${1}/?company_id=${this.compan.id}`
                    await axios.get(url).then(res => {
                         this.operationslevelones = res.data.map(type => {
                            return { value: type.id, text: type.name_operation_level_one }
                        })
                      
                    })
                },

        },
        mounted(){
            this.loadOwnerContracts()
            this.loadOwners()
            this.loadFinancialBoxs()
            this.loadOperationsLevelOnes()
            this.showTable = true
        }
}
</script>

<style>

    .ownercontract-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .ownercontract-search button{
        font-size: 0.75rem;
    }

     .ownercontract-search select{
        font-size: 0.75rem;
    }

    .ownercontract-search input{
        font-size: 0.75rem;
    }

    .ownercontract-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }

    #modalFile {
        font-size: 0.75rem;
    }

    #modalFile button{
        font-size: 0.75rem;
    }

     #modalFile input{
        font-size: 0.75rem;
    }

      #modalFile label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobileContract {
        font-size: 0.75rem;
    }

    #modalImmobileContract button{
        font-size: 0.75rem;
    }

     #modalImmobileContract input{
        font-size: 0.75rem;
    }

      #modalImmobileContract select{
        font-size: 0.75rem;
    }

      #modalImmobileContract label{
        font-size: 0.75rem;
        color: black;
    }



    #modalFinancialContract {
            font-size: 0.75rem;
        }

    #modalFinancialContract button{
        font-size: 0.75rem;
    }

     #modalFinancialContract input{
        font-size: 0.75rem;
    }

     #modalFinancialContract textarea{
        font-size: 0.75rem;
    }

    #modalFinancialContract label{
        font-size: 0.75rem;
        color: black;
    }

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
